if (!customElements.get('advanced-video-offer')) {
  class AdvancedVideoOffer extends HTMLElement {
    constructor () {
      super();

      this.atcSyncRafId = null;
      this.atcSyncTimeoutId = null;

      this.handleLocalInputChange = this.handleLocalInputChange.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback () {
      this.addEventListener('change', this.handleLocalInputChange);
      this.addEventListener('quantityChanged', this.handleLocalInputChange);
      document.addEventListener('variant:change', this.handleVariantChange);

      this.syncATCTexts();
    }

    disconnectedCallback () {
      this.removeEventListener('change', this.handleLocalInputChange);
      this.removeEventListener('quantityChanged', this.handleLocalInputChange);
      document.removeEventListener('variant:change', this.handleVariantChange);

      if (this.atcSyncRafId !== null) {
        cancelAnimationFrame(this.atcSyncRafId);
      }

      if (this.atcSyncTimeoutId !== null) {
        clearTimeout(this.atcSyncTimeoutId);
      }
    }

    handleVariantChange () {
      this.scheduleATCSync();
    }

    handleLocalInputChange (event) {
      const target = event?.target;
      if (!(target instanceof HTMLElement)) return;

      const card = target.closest('.advanced-video-offer-card[data-card-id]');
      if (!card || !this.contains(card)) return;

      this.scheduleATCSync(card);
    }

    scheduleATCSync (card = null) {
      if (this.atcSyncRafId !== null) {
        cancelAnimationFrame(this.atcSyncRafId);
      }

      if (this.atcSyncTimeoutId !== null) {
        clearTimeout(this.atcSyncTimeoutId);
      }

      this.atcSyncRafId = requestAnimationFrame(() => {
        this.atcSyncRafId = null;

        if (card) {
          this.syncATCText(card);
        } else {
          this.syncATCTexts();
        }

        this.atcSyncTimeoutId = window.setTimeout(() => {
          this.atcSyncTimeoutId = null;

          if (card) {
            this.syncATCText(card);
          } else {
            this.syncATCTexts();
          }
        }, 0);
      });
    }

    syncATCTexts () {
      this.querySelectorAll('.advanced-video-offer-card[data-card-id]').forEach((card) => {
        this.syncATCText(card);
      });
    }

    syncATCText (card) {
      const cardId = card?.dataset?.cardId;
      if (!cardId) return;

      const addToCartButton = card.querySelector(`#AddToCart-${cardId}`);
      const addToCartText = card.querySelector(`#AddToCartText-${cardId}`);

      if (!addToCartButton || !addToCartText) return;
      if (addToCartButton.disabled) return;

      const { defaultText } = addToCartText.dataset;
      if (!defaultText) return;

      addToCartText.textContent = defaultText;
    }
  }

  customElements.define('advanced-video-offer', AdvancedVideoOffer);
}
